<template>
  <div>
    <klickpages-header
      v-if="showKlickpagesHeader"
      :klickartURL="klickartURL"
      :jwtSecret="jwtSecret"
      :hotmartURL="hotmartURL"
    />
    <error-page v-show="error" :error="error"></error-page>
    <router-view v-show="!error"></router-view>
    <klickpages-support-chat :klickartURL="klickartURL" />
  </div>
</template>

<script>
import apiInstance from './helpers/request/api/instance';
import ErrorPage from './components/general/ErrorPage.vue';
import User from './helpers/request/user';
import { mapGetters } from 'vuex';
import rebrand from './config/rebrand';

const UserRequest = new User();

export default {
  components: {
    ErrorPage,
  },
  data() {
    return {
      hotmartURL: process.env.HOTMART_URL,
      klickartURL: rebrand.urls.KLICKART_URL.replace('http:', 'https:'),
      jwtSecret: process.env.KLICKPAGES_HEADER_JWT_SECRET,
      error: false,
    };
  },
  computed: {
    ...mapGetters([
      'showKlickpagesHeader',
    ]),
  },
  beforeCreate() {
    const instance = apiInstance();

    instance.interceptors.response.use(response => {
      this.error = null;

      return Promise.resolve(response);
    }, error => {
      if (error.config.catchError) {
        this.error = error.response.status;
      }

      return Promise.reject(error);
    });
  },
  created() {
    UserRequest.identifier()
      .then((response) => {
        this.$ga.set('userId', response.data.identifier);
        this.$ga.page(this.$router);
      });
  },
};
</script>



/** WEBPACK FOOTER **
 ** App.vue?754f063e
 **/